export default __webpack_public_path__ + "static/media/HillHouses.8cdac831.svg";